import { PlainI18nProps } from "shared/types/i18n";
import { twMerge } from "tailwind-merge";

import { LoadingIndicator } from "./loading-spinner";

export const LoadingScreen: React.FC<{
  message?: PlainI18nProps;
  className?: string;
}> = ({ message = { tx: "general.loading" }, className }) => {
  return (
    <div
      className={twMerge(
        "flex h-full w-full items-center justify-center",
        className,
      )}
    >
      <LoadingIndicator as="spinner" className={className} message={message} />
    </div>
  );
};
